// extracted by mini-css-extract-plugin
export default {"title":"ReferralCodePage_title__B-DSe","successMessage":"ReferralCodePage_successMessage__dG3sY"};